import MappingContainer from './MappingContainer'
import React, {useEffect} from 'react'
import {useNavigate, useParams, useSearchParams} from 'react-router-dom'
import {getEnvironment} from '../../services/AuthServices'
import {getLocalData, setLocalData} from '../../services/StorageServices'
import {authorizeWithStoreSlug, fetchPublicStoreSettingsBySlug} from '../../services/SellerServices'
import {Spinner} from 'reactstrap'

const ShopifyMappingContainer = () => {
    const navigate = useNavigate()
    const [params] = useSearchParams()
    const {productId} = useParams()
    const [loading, setLoading] = React.useState(true)
    const env = getEnvironment()
    const getConfigValue = (envValue, paramKey, localKey) => {
        return env === 'development' ? envValue : params.get(paramKey) || getLocalData(localKey)
    }

    const path = getConfigValue(process.env.REACT_APP_PATH, 'path', 'path')
    const storeId = getConfigValue(process.env.REACT_APP_STORE_ID, 'storeId', 'storeId')
    const accessToken = getConfigValue(process.env.REACT_APP_ACCESS_TOKEN, 'accessToken', 'accessToken')
    const variantId = getConfigValue(process.env.REACT_APP_VARIANT_ID, 'variantId', 'variantId')

    useEffect(() => {
        setLocalData('path', '')
        setLocalData('storeId', '')
    }, [])

    const _authorize = async (storeId) => {
        if (!storeId) return
        const {success, data, message} = await authorizeWithStoreSlug(storeId)
        if (!success) throw new Error(message)
        setLocalData('storeRoles', JSON.stringify(data.roles))
        setLocalData('storeSettings', JSON.stringify(data.settings))
    }

    const _fetchStoreSettings = async (storeId) => {
        if (!storeId) return
        const {success, data, message} = await fetchPublicStoreSettingsBySlug(storeId)
        if (!success) throw new Error(message)
        setLocalData('currentStoreSettings', JSON.stringify(data))
    }

    const _handleRedirect = async (storeId) => {
        try {
            await Promise.all([
                _fetchStoreSettings(storeId),
                _authorize(storeId)
            ])
            let url = `/mapping-variants/${productId}`
            if (variantId) {
                url += `?variantId=${variantId}`
            }
            navigate(url, {replace: true})
            setLoading(false)
        } catch (error) {
            setLocalData('storeRoles', '')
            setLocalData('storeSettings', '')
            setLocalData('currentStoreSettings', '')
            setLocalData('accessToken', '')
            setLocalData('path', '')
            setLocalData('storeId', '')
        }
    }

    useEffect(() => {
        setLocalData('path', path)
        setLocalData('accessToken', accessToken)
    }, [path, accessToken])

    useEffect(() => {
        setLocalData('storeId', storeId)
        setLocalData('storeRoles', JSON.stringify([]))
        _handleRedirect(storeId)
    }, [productId, storeId])

    return loading ? (
        <div className="LoadingWrapper">
            <Spinner style={{color: '#007BFF'}} />
        </div>
    ) : (
        <div>
            <MappingContainer />
        </div>
    )
}

export default ShopifyMappingContainer

